import { IS_EMAIL, IS_PHONE_NUMBER } from '../../utils/validators';
import { localisable } from '../../generic/localisable';
import { commonInputStyleProps } from './constants';

export const formConfig = () => ({
    name: {
        name: "name",
        required: true,
        label: localisable.name,
        type: 'text',
        placeholder: localisable.enterName,
        _placeholder: {
            textStyle: 'body2'
        },
        inputStyleProps: {
            ...commonInputStyleProps,
        },
    },
    phone: {
        name: "phone",
        label: localisable.phone,
        type: 'tel',
        required: true,
        validate: IS_PHONE_NUMBER,
        placeholder: localisable.enterPhoneNumber,
        _placeholder: {
            textStyle: 'body2'
        },
        inputStyleProps: {
            ...commonInputStyleProps,
        }
    },
    email: {
        name: "email",
        label: localisable.email,
        type: 'email',
        required: true,
        validate: IS_EMAIL,
        placeholder: localisable.enterEmail,
        _placeholder: {
            textStyle: 'body2'
        },
        inputStyleProps: {
            ...commonInputStyleProps,
        }
    },
    subject: {
        name: "subject",
        label: localisable.subject,
        type: 'text',
        placeholder: localisable.enterSubject,
        _placeholder: {
            textStyle: 'body2'
        },
        inputStyleProps: {
            ...commonInputStyleProps,
        }
    },
    message: {
        name: "message",
        label: localisable.message,
        placeholder: localisable.enterMessage,
        required: true,
        resize: 'none',
        _placeholder: {
            textStyle: 'body2'
        },
        inputStyleProps: {
            ...commonInputStyleProps,
            h: '212px',
        }
    },
});

export const dropdownConfig = {
    name: "dropdown",
    label: localisable.label,
    required: true,
};